/* tslint:disable */
/* eslint-disable */
/**
 * API Gateway
 * This API provides user authentication and profile management.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const V1PaymentsKind = {
    Subscription: 'subscription',
    Programme: 'programme',
    SellProgramme: 'sell_programme',
    RequestWorkout: 'request_workout',
    SellCustomWorkout: 'sell_custom_workout'
} as const
export type V1PaymentsKind =
    (typeof V1PaymentsKind)[keyof typeof V1PaymentsKind]

export function instanceOfV1PaymentsKind(value: any): boolean {
    for (const key in V1PaymentsKind) {
        if (Object.prototype.hasOwnProperty.call(V1PaymentsKind, key)) {
            if (V1PaymentsKind[key as keyof typeof V1PaymentsKind] === value) {
                return true
            }
        }
    }
    return false
}

export function V1PaymentsKindFromJSON(json: any): V1PaymentsKind {
    return V1PaymentsKindFromJSONTyped(json, false)
}

export function V1PaymentsKindFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean
): V1PaymentsKind {
    return json as V1PaymentsKind
}

export function V1PaymentsKindToJSON(value?: V1PaymentsKind | null): any {
    return value as any
}

export function V1PaymentsKindToJSONTyped(
    value: any,
    ignoreDiscriminator: boolean
): V1PaymentsKind {
    return value as V1PaymentsKind
}
